import { SetNotiTimeService } from '../service/SetNotiTimeService';
import Env, { timezone } from '~/notify/settings/__modules__/utils/Env';

export { timezone as TIME_ZONE };
export const DEFAULT_TIME = {
  startTime: '07:00',
  endTime: '22:00',
  weekdays: [0, 1, 2, 3, 4, 5, 6],
};

const defaultOptions = {
  enable: false,
  enableHoliday: false,
  type: 1,
  timeSettings: [],
};
export class SetNotiTimeBiz {
  static async getNotiTimeOptions() {
    const optionValue = await SetNotiTimeService.getNotiTimeOptions();
    let result = { ...defaultOptions };
    if (optionValue) {
      // 3.1
      if (optionValue.type === 1) {
        result = { ...defaultOptions, ...optionValue };
      } else {
        // 3.0
        const [
          startTimeHour,
          startTimeMin,
        ] = SetNotiTimeBiz.getGMTorTimezoneTime(
          optionValue.startTimeHour,
          optionValue.startTimeMin,
          'gmt',
        );
        const [endTimeHour, endTimeMin] = SetNotiTimeBiz.getGMTorTimezoneTime(
          optionValue.endTimeHour,
          optionValue.endTimeMin,
          'gmt',
        );

        let option = {
          enable: optionValue.enable,
          timeSettings: [
            {
              startTimeHour: endTimeHour,
              startTimeMin: endTimeMin,
              endTimeHour: startTimeHour,
              endTimeMin: startTimeMin,
              weekdays: [0, 1, 2, 3, 4, 5, 6],
            },
          ],
        };
        result = { ...defaultOptions, ...option };
      }
    }
    return result;
  }

  static async init() {
    const result = await SetNotiTimeBiz.getNotiTimeOptions();
    result.timeSettings = result.timeSettings.map((item) => {
      const [startHour, startMin] = [item.startTimeHour, item.startTimeMin];
      const [endHour, endtMin] = [item.endTimeHour, item.endTimeMin];
      const startTime = `${SetNotiTimeBiz.formatTime(
        startHour,
        'hour',
      )}:${SetNotiTimeBiz.formatTime(startMin, 'min')}`;

      const endTime = `${SetNotiTimeBiz.formatTime(
        endHour,
        'hour',
      )}:${SetNotiTimeBiz.formatTime(endtMin, 'min')}`;

      return {
        startTime,
        endTime,
        weekdays: item.weekdays?.sort(),
        uuid: SetNotiTimeBiz.uuid(),
      };
    });
    // If the server does not return a value (The default value is a timezone time)
    if (result.timeSettings.length === 0) {
      result.timeSettings = [
        {
          ...DEFAULT_TIME,
          uuid: SetNotiTimeBiz.uuid(),
        },
      ];
    }
    return result;
  }

  static async save(option) {
    const timeSettings = option.timeSettings.map((item) => {
      // const [startHour, startMin] = item.startTime.split(':');
      // const [startTimeHour, startTimeMin] = SetNotiTimeBiz.getGMTorTimezoneTime(
      //   startHour,
      //   startMin,
      //   'timezone',
      // );
      // const [endHour, endMin] = item.endTime.split(':');
      // const [endTimeHour, endTimeMin] = SetNotiTimeBiz.getGMTorTimezoneTime(
      //   endHour,
      //   endMin,
      //   'timezone',
      // );
      const [startTimeHour, startTimeMin] = item.startTime.split(':');
      const [endTimeHour, endTimeMin] = item.endTime.split(':');

      return {
        startTimeHour: +startTimeHour,
        startTimeMin: +startTimeMin,
        endTimeHour: +endTimeHour,
        endTimeMin: +endTimeMin,
        weekdays: item.weekdays,
      };
    });

    const params = {
      ...option,
      timeSettings,
    };
    const success = await SetNotiTimeService.saveNotiTimeOptions(params);
    return !!success;
  }

  static getGMTorTimezoneTime(hour, minute, timetype) {
    const offset = Env.getOffset();
    let date = new Date();
    date.setHours(hour);
    date.setMinutes(minute);
    const timestamp =
      timetype === 'gmt'
        ? date.getTime() + offset * 60 * 1000
        : date.getTime() - offset * 60 * 1000;

    let time = new Date(timestamp);
    return [time.getHours(), time.getMinutes()];
  }

  static getGMTOffset() {
    const found = Env.getGMTOffsetObj();
    if (!found) return '';
    return `${found.name} ${found.gmt}`;
  }

  static formatTime(time, type) {
    if (type === 'hour') {
      time = time >= 23 ? 23 : time;
    } else if (type === 'min') {
      time = time >= 59 ? 59 : time;
    }
    let result = time >= 0 && time < 10 ? '0' + time : time;
    return result;
  }

  static uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (
      c,
    ) {
      const randomArray = new Uint32Array(1);
      window.crypto.getRandomValues(randomArray);
      const r = randomArray[0] % 16;
      const v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}
